import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuthMode } from "@/hooks/useAuthForm";

export const useAuthMode = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialMode = searchParams.get("mode") === "signup" ? "signup" : "email";
  const verifyEmail = searchParams.get("verify") === "email";
  
  const [mode, setMode] = useState<AuthMode>(initialMode as AuthMode);

  // Set the initial mode based on URL parameters
  useEffect(() => {
    if (verifyEmail) {
      setMode("verify-email");
    } else {
      setMode(initialMode as AuthMode);
    }
  }, [initialMode, verifyEmail]);

  // Listen for custom events to change the auth mode
  useEffect(() => {
    const handleModeChange = (e: CustomEvent<AuthMode>) => {
      if (e.detail && ["email", "signup", "verify-email"].includes(e.detail)) {
        setMode(e.detail);
      }
    };
    
    document.addEventListener("auth-mode-change", handleModeChange as EventListener);
    
    return () => {
      document.removeEventListener("auth-mode-change", handleModeChange as EventListener);
    };
  }, []);

  return { mode, setMode, urlParams: searchParams };
};